





























import { RestClient } from '@/features/core/rest-client/rest-client';
import {
  AddVendorInput,
  AddVendorOutPut,
  AddVendorResponseforGenericNotificationAPI,
} from '@/types/notification-api.model';
import { VendorApiType } from '@/types/iot-portal';
import { isNonEmptyString } from '@/util/string';
import { defineComponent } from '@vue/composition-api';
import type { MethodOptions } from '@vue/composition-api';
import { EMPTY, lastValueFrom } from 'rxjs';
import { getRxjsHttpErrorResponseBody, getRxjsHttpErrorStatus } from '@/features/core/util/rxjs-http-error-response';

interface GenericNotificationApiViewProps {
  customerId: string;
}

interface GenericNotificationApiViewData {
  isNonEmptyString: typeof isNonEmptyString;
  client?: RestClient;
}

export default defineComponent<
  GenericNotificationApiViewProps,
  Record<string, unknown>,
  GenericNotificationApiViewData,
  Record<string, never>,
  MethodOptions
>({
  inject: ['GENERIC_NOTIFICATION_API_REST_CLIENT'],
  props: {
    customerId: { type: String, required: true },
  },
  data() {
    return {
      isNonEmptyString,
      client: undefined as RestClient | undefined,
    };
  },
  created() {
    this.client = this.GENERIC_NOTIFICATION_API_REST_CLIENT as unknown as RestClient;
  },
  methods: {
    isValidData(data: Partial<AddVendorInput>): boolean {
      return this.isNonEmptyString(data.label);
    },
    async addGenericNotificationApi(input: AddVendorInput): Promise<AddVendorOutPut> {
      try {
        const response: AddVendorResponseforGenericNotificationAPI = await lastValueFrom(
          this.client?.post('/api/v2/notification', {
            customerId: this.customerId,
            vendorName: 'GenericNotificationApi',
            ...input,
            label: input.label,
          }) ?? EMPTY,
        );

        return {
          id: response.thirdPartyConfigId.toString(),
          label: input.label,
          __typename: 'GenericNotificationApi',
          type: VendorApiType.GenericNotificationApi,
        };
      } catch (error) {
        const responseBody = await getRxjsHttpErrorResponseBody(error);

        if (getRxjsHttpErrorStatus(error) === 409 && responseBody?.error?.message === 'label_already_exists') {
          throw new Error('Eine Generic Notification API mit diesem Beschriftung existiert bereits.');
        }
        throw error;
      }
    },
  },
});
